import React, { useState } from 'react';
import './customerMessageCard.scss';

const CustomerMessageCarde = ({ remarks, customerRemarks }) => {
  const [isActive, setActive] = useState(false);

  const handleToggle = () => {
    setActive(!isActive);
  };
  return (
    <div className={`${'message_detials'} ${isActive ? 'active' : ''}`}>
      <div className="accordion_title">
        <strong>Message from Customer</strong>
        <span className="animatedarrow" onClick={handleToggle}></span>
      </div>
      <div className="message_content">
        {customerRemarks ? <p>{customerRemarks}</p> : ''}
        {remarks && remarks.remarks ? <p>{remarks.remarks}</p> : ''}
      </div>
    </div>
  );
};

export default CustomerMessageCarde;
